// removed by extract-text-webpack-plugin
module.exports = {"archiveHeader":"archive__archiveHeader_2XJGf","archiveContent":"archive__archiveContent_1OT52","series":"archive__series_1b3cQ","image":"archive__image_q13qm"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/archive/styles.less
// module id = ./src/client/components/archive/styles.less
// module chunks = comics